import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import Image from 'next/image';
interface Props {
  link: string;
  label: string;
}
export default function TelegramLink(t0) {
  const $ = _c(6);
  const {
    link,
    label
  } = t0;
  const t1 = `https://t.me/${link}`;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="relative w-10 h-10"><Image src="/telegram-logo.svg" alt="Telegram Social Link" priority={true} fill={true} /></div>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== label) {
    t3 = <p className="mt-1 text-center">{label}</p>;
    $[1] = label;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t1 || $[4] !== t3) {
    t4 = <Link href={t1} className="relative flex flex-col items-center justify-center">{t2}{t3}</Link>;
    $[3] = t1;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}